import { convexQuery, useConvexMutation } from "@convex-dev/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";
import type { Id } from "@teachloop/backend/_generated/dataModel";
import { useRouter } from "expo-router";
import React, { Fragment, useEffect, useState } from "react";
import { Text, View } from "react-native";
import { Button } from "../ui/button";
import { api } from "../utils/convex-api";
import LessonHistorySubjectList from "./lesson-history-subject-list";
import TutorLessonHistoryItem from "./tutor-lesson-history-item";

function TutorLessonHistoryHome() {
  const { data: lessonHistorySubjectsData } = useQuery(
    convexQuery(api.tutor.home.queries.getLessonReportSubjects, {}),
  );
  const lessonHistorySubjects = lessonHistorySubjectsData ?? [];

  const [firstSubject] = lessonHistorySubjects;
  const firstSubjectId = firstSubject?.id;

  const [selectedSubjectId, setSelectedSubjectId] =
    useState<Id<"subjects"> | null>(null);

  const { data: lessonReportsData } = useQuery(
    convexQuery(
      api.tutor.home.queries.getLessonReports,
      selectedSubjectId
        ? {
            subjectId: selectedSubjectId,
          }
        : "skip",
    ),
  );
  const lessonReports = lessonReportsData ?? [];
  const router = useRouter();

  const { mutateAsync: processLessonReport } = useMutation({
    mutationFn: useConvexMutation(api.tutor.home.mutations.processLessonReport),
  });

  useEffect(() => {
    if (firstSubjectId && !selectedSubjectId) {
      setSelectedSubjectId(firstSubjectId);
    }
  }, [firstSubjectId, selectedSubjectId]);

  if (lessonHistorySubjects.length === 0) {
    return <Fragment />;
  }

  return (
    <View className="gap-4 mt-4">
      <Text className="font-geologica-medium font-medium text-[20px] text-gray-800 leading-[1.5]">
        Lesson history
      </Text>
      <LessonHistorySubjectList
        lessonHistorySubjects={lessonHistorySubjects}
        selectedSubjectId={selectedSubjectId}
        setSelectedSubjectId={setSelectedSubjectId}
      />
      <View>
        {lessonReports.slice(0, 3).map((item) => (
          <Fragment key={item._id}>
            <TutorLessonHistoryItem
              item={item}
              onProcessLessonReport={processLessonReport}
            />

            <View className="h-[1px] bg-gray-200" />
          </Fragment>
        ))}
      </View>

      <View className="items-end">
        {lessonReports.length > 3 && (
          <Button
            size="sm"
            outline
            className="border"
            onPress={() => {
              router.push("/(app)/lesson-history");
            }}
          >
            <Button.Text size="sm" intent="primary">
              See full history
            </Button.Text>
          </Button>
        )}
      </View>
    </View>
  );
}

export default TutorLessonHistoryHome;
